<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="title">活动信息</div>
      <div class="content">
        <div class="item">
          <div class="re-title">
            <i>*</i>活动名称
          </div>
          <div class="re-content">
            <el-input v-model="formData.privateThemeName" placeholder="请输入活动名称" />
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>活动主题
          </div>
          <div class="re-content">
            <el-select v-model="themeName" placeholder="选择活动主题" @change="getChannelList" filterable :disabled="type !== 'new'">
              <el-option
                v-for="themeItem in themeList"
                :key="themeItem.themeName"
                :label="themeItem.themeName"
                :value="themeItem.themeName"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>渠道
          </div>
          <div class="re-content">
            <el-select
              v-model="formData.channelCode"
              placeholder="选择渠道"
              @change="getThemeDefineId"
              :disabled="type === 'copy' || type === 'update'"
            >
              <el-option
                v-for="channelItem in channelList"
                :key="channelItem.channelCode"
                :label="channelItem.channelCode"
                :value="channelItem.channelCode"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>选择Region
          </div>
          <div class="re-content" style="display:flex">
            <el-select
              v-model="formData.orgCodes"
              placeholder="请选择Region"
              @change="getLimitInfo"
              :disabled="type === 'copy' || type === 'update'"
            >
              <el-option v-for="orgItem in orgList" :key="orgItem.orgId" :label="orgItem.orgName" :value="orgItem.orgCode"></el-option>
            </el-select>
          </div>
        </div>
        <div class="item" v-if="areaList.length">
          <div class="re-title">
            <i>*</i>选择Area
            <div class="tips">该活动只向已选择Area开放</div>
          </div>
          <div class="re-content">
            <div class="area">
              <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="checkbox-checkAll">全选</el-checkbox>
              <el-checkbox-group v-model="selectAreaList" @change="handleCheckedAreaChange" class="checkbox-group">
                <el-checkbox v-for="item,index in areaList" :key="index" :label="item.orgCode">{{item.orgName.split('|')[0]}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="re-title">
            <i>*</i>活动时间
            <div class="tips">截止时间为活动结束时间</div>
          </div>
          <div class="re-content">
            <el-date-picker
              v-model="formData.startDate"
              align="right"
              type="date"
              placeholder="开始时间"
              :picker-options="disableStartDate"
              value-format="timestamp"
              @change="checkData"
            ></el-date-picker>&nbsp;&nbsp;&nbsp;&nbsp;
            至
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-date-picker
              v-model="formData.endDate"
              align="right"
              type="date"
              placeholder="结束时间"
              :picker-options="disableEndDate"
              value-format="timestamp"
              @change="checkData"
              default-time="23:59:59"
            ></el-date-picker>
          </div>
        </div>
        <div class="item" v-if="limitInfo.themeDefineId">
          <div class="re-title">
            <i>*</i>最小执行时间（天）
            <div class="tips">不能小于{{limitInfo.execDaysMin}}天</div>
          </div>
          <div class="re-content">
            <el-input-number v-model="formData.execDaysMin" :min="limitInfo.execDaysMin" :precision="0"></el-input-number>
          </div>
        </div>
        <div class="item" v-if="limitInfo.themeDefineId">
          <div class="re-title">
            <i>*</i>打卡频次（天/次）
            <div class="tips">最大值：{{limitInfo.execDaysCycle}}</div>
          </div>
          <div class="re-content">
            <el-input-number v-model="formData.execDaysCycle" :max="limitInfo.execDaysCycle" :precision="0"></el-input-number>
          </div>
        </div>
        <div class="item" v-if="limitInfo.themeDefineId">
          <div class="re-title">
            <i>*</i>陈列追踪方式
          </div>
          <div class="re-content">
            <el-button size="mini" type="primary" class="exec-cycle-btn">售点追踪</el-button>
          </div>
        </div>
        <div class="item" v-if="limitInfo.themeDefineId">
          <div class="re-title">
            <i>*</i>费用返还方式
          </div>
          <div class="re-content">
            <div class="checkbox-info">
              <el-checkbox-group
                v-model="selectBonusTypeScopeList"
                v-for="item in bonusTypeScopeList"
                :key="item.value"
                class="checkbox-wrapper"
              >
                <el-checkbox-button v-if="item.type === 0" size="mini" :label="item.value" @change="setBonusTypeScope">{{item.key}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff" v-if="checkBonusTypeScopeType(bonusTypeScopeList, 0)">
                <i class="el-icon-info"></i> 无交易售点
              </span>
            </div>
            <div class="checkbox-info">
              <el-checkbox-group
                v-model="selectBonusTypeScopeList"
                v-for="item in bonusTypeScopeList"
                :key="item.value"
                class="checkbox-wrapper"
              >
                <el-checkbox-button v-if="item.type === 1" size="mini" :label="item.value" @change="setBonusTypeScope">{{item.key}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff" v-if="checkBonusTypeScopeType(bonusTypeScopeList, 1)">
                <i class="el-icon-info"></i> 有交易售点
              </span>
            </div>
          </div>
        </div>
        <div class="item" v-if="limitInfo.themeDefineId">
          <div class="re-title" style="width:200px"></div>
          <div class="re-content">
            <div class="bonus" style="margin:10px 0" v-if="formData.bonusTypeScope.indexOf('01') !== -1">
              <div class="bonus-title">线上现金返还设置</div>
              <div class="bonus-content">
                <div style="width:30%">
                  <i>*</i> 陈列费/次（元）
                </div>
                <div style="width:70%">
                  <SwitchInput
                    ref="onlineBonusFee"
                    taskName="displayFees"
                    :key="formData.bonusFeeChooseType"
                    :bonusChooseType="formData.bonusFeeChooseType"
                    :switchValue="getOnlineFeeSwitchValue(formData.bonusFeeChooseType)"
                  ></SwitchInput>
                </div>
              </div>
            </div>
            <div class="bonus" style="margin:10px 0" v-if="formData.bonusTypeScope.indexOf('02') !== -1">
              <div class="bonus-title">线下现金返还设置</div>
              <div class="bonus-content">
                <div style="width:30%">
                  <i>*</i> 陈列费/次（元）
                </div>
                <div style="width:70%">
                  <SwitchInput
                    ref="offlineBonusFee"
                    taskName="displayFees"
                    :key="formData.offlineFeeChooseType"
                    :bonusChooseType="formData.offlineFeeChooseType"
                    :switchValue="getOfflineFeeSwitchValue(formData.offlineFeeChooseType)"
                  ></SwitchInput>
                </div>
              </div>
            </div>
            <div class="bonus" style="margin:10px 0" v-if="formData.bonusTypeScope.indexOf('03') !== -1">
              <div class="bonus-title">线下免费酒返还设置</div>
              <div class="bonus-content">
                <div style="width:30%">
                  <i>*</i> 赠酒SKU
                </div>
                <div style="width:70%">
                  <RegionSkuDialog ref="bonusBeerSku" type="bonusBeerSku" :bonusBeerScope="formData.bonusBeerScope"></RegionSkuDialog>
                </div>
              </div>
              <div class="bonus-content">
                <div style="width:30%">
                  <i>*</i> 赠酒数/次（箱）
                </div>
                <div style="width:70%">
                  <SwitchInput
                    :key="formData.bonusBeerChooseType"
                    ref="BonusBeer"
                    taskName="giveMine"
                    :bonusChooseType="formData.bonusBeerChooseType"
                    :switchValue="getBeerSwitchValue(formData.bonusBeerChooseType)"
                  ></SwitchInput>
                </div>
              </div>
            </div>
            <div class="bonus" style="margin:10px 0" v-if="formData.bonusTypeScope.indexOf('04') !== -1">
              <div class="bonus-title" style="line-height:40px;padding-top:10px">先蜂购线上免费酒返还设置</div>
              <div class="bonus-content">
                <RegionBeesBonusBeer
                  ref="BonusBeerOnline"
                  :monthList="reportCycleList"
                  :dataList="tradePerfectBonusBeerGroupList"
                  type="edit"
                  :themeStatus="formData.themeStatus"
                  :handleType="type"
                ></RegionBeesBonusBeer>
                <div class="coupon-bonus-beer" style="width:100%">
                  <div style="width:30%">
                    <i>*</i> 赠酒券有效时间
                  </div>
                  <div style="width:70%">
                    <div>
                      <el-radio v-model="beesCouponAssignRule.type" label="01" @change="shiftBeesCouponAssignRule">&nbsp;</el-radio>发券后
                      <el-input-number
                        v-model="beesCouponAssignRule.validDays"
                        :min="1"
                        :precision="0"
                        style="margin:0 5px"
                        placeholder="请输入"
                        :disabled="beesCouponAssignRule.type === '02'"
                      ></el-input-number>天内
                    </div>
                    <div>
                      <el-radio v-model="beesCouponAssignRule.type" @change="shiftBeesCouponAssignRule" label="02">&nbsp;</el-radio>永久有效
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bonus" style="margin:10px 0" v-if="formData.bonusTypeScope.indexOf('05') !== -1">
              <div class="bonus-title">先蜂购线上折扣金返还设置</div>
              <div class="bonus-content">
                <div style="width:30%">
                  <i>*</i> 折扣金/次（元）
                </div>
                <div style="width:70%">
                  <SwitchInput
                    ref="beesFeeBonus"
                    taskName="displayFees"
                    :key="formData.beesFeeChooseType"
                    :bonusChooseType="formData.beesFeeChooseType"
                    :switchValue="getBeesBonusFee(formData.beesFeeChooseType)"
                    :canZero="true"
                  ></SwitchInput>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="taskCheckedList.length" class="regionTask">
        <!-- <div> -->
        <!-- tab栏 -->
        <el-tabs v-model="activeName">
          <template v-for="item in taskCheckedList">
            <el-tab-pane
              v-if="item.key !== '05' || (item.key === '05' && checkBonusTypeScopeType(bonusTypeScopeList, 1) && (selectBonusTypeScopeList.includes('04') || selectBonusTypeScopeList.includes('05')))"
              :key="item.key"
              :label="item.title"
              :name="item.title"
            ></el-tab-pane>
          </template>
        </el-tabs>
        <!-- 选项卡 -->
        <!-- 堆箱任务 -->
        <div class="tab-content" v-show="activeName==='堆箱任务'">
          <DisplayPackDesign
            ref="packDesign"
            type="add"
            :selectedData="packTaskSelected.mixinPackScopeList"
            :dataList="buPackTaskInfo.mixinPackScopeList"
          ></DisplayPackDesign>
          <DisplayMixin
            taskName="堆箱"
            ref="packMixin"
            style="margin-top:5px"
            type="add"
            :selectedData="packTaskSelected.mixinDisplayScopeList"
            :dataList="buPackTaskInfo.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 货架任务 -->
        <div class="tab-content" v-show="activeName==='货架任务'">
          <DisplayMandatory
            ref="shelvesMandatory"
            type="add"
            :selectedData="shelvesTaskSelected.mandatoryScopeList"
            :dataList="buShelvesTaskInfo.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            taskName="货架"
            ref="shelvesMixin"
            style="margin-top:5px"
            type="add"
            :dataList="buShelvesTaskInfo.mixinDisplayScopeList"
            :selectedData="shelvesTaskSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 冰柜任务 -->
        <div class="tab-content" v-show="activeName==='冰柜任务'">
          <DisplayMandatory
            ref="freezerMandatory"
            type="add"
            :selectedData="FreezerTaskSelected.mandatoryScopeList"
            :dataList="buFreezerTaskInfo.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            taskName="冰柜"
            ref="freezerMixin"
            style="margin-top:5px"
            type="add"
            :dataList="buFreezerTaskInfo.mixinDisplayScopeList"
            :selectedData="FreezerTaskSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <div class="tab-content" v-show="activeName==='STR任务'">
          <RegionStr
            ref="regionStr"
            :strTaskList="strTaskInfo.saleScopeList"
            :monthList="reportCycleList"
            :themeStatus="formData.themeStatus"
            :handleType="type"
          ></RegionStr>
        </div>
      </div>
    </div>
    <div class="handle-foot" v-show="taskCheckedList.length">
      <el-button class="btn-red" @click="execFormData(1)" v-if="formData.themeStatus !== 100 || type ==='copy'" :loading="btnLoading">保存</el-button>
      <el-button class="btn-red" @click="execFormData(2)" :loading="btnLoading">提交</el-button>
    </div>
    <el-dialog :visible="showBudgetDialog" title="选择预算池" width="40%" :show-close="false">
      <el-row>
        <el-col :span="12">
          <span style="margin-right: 2px; color: #cd1231">*</span>入账品牌
          <el-select v-model="formData.entryBrandCode" @change="recordedBrandChange" filterable clearable>
            <el-option :value="item.brandCode" :label="item.brandName" v-for="item,index in recordedBrandList" :key="index"></el-option>
          </el-select>
        </el-col>
        <el-col :span="11">
          <span style="margin-right: 2px; color: #cd1231">*</span>预算池
          <el-select v-model="formData.budgetTypeId" filterable clearable>
            <el-option
              :label="`${item.typeName} ( ${item.trCodeName} ) - ${newThousandSymbol(item.tradeBudgetInfoCountDTO)}`"
              :value="item.typeId"
              v-for="item,index in budgetList"
              :key="index"
              style="height:70px;line-height:0"
            >
              <div
                class="name"
                style="font-size:16px;font-weight:700;color:#888888;line-height:25px;padding-top:7px"
              >{{`${item.typeName} (${item.trCode})`}}</div>
              <div
                class="available"
                style="display:inline-block;background-color: #FAE6EA;color: #cd1231;padding:0 10px;border-radius:3px;line-height:25px"
              >{{newThousandSymbol(item.tradeBudgetInfoCountDTO)}}</div>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :offset="1">
          <div style="padding-top: 40px;color: #c8102d">当前预算池配置仅适用于无交易售点活动</div>
        </el-col>
      </el-row>
      <div class="handle-foot" style="margin-top:30px">
        <el-button class="btn-red" @click="budgetCancel" :loading="btnLoading">取消</el-button>
        <el-button class="btn-red" @click="budgetSubmit" :loading="btnLoading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import SwitchInput from '@/views/trade/perfect2022/components/perfect-switch-input'
import RegionSkuDialog from '@/views/trade/perfect2022/components/region-sku-dialog.vue'
import RegionBeesBonusBeer from '@/views/trade/perfect2022/components/region-bees-bonus-beer.vue'
import DisplayPackDesign from '@/views/trade/perfect2022/components/display-pack-design'
import DisplayMixin from '@/views/trade/perfect2022/components/display-mixin'
import DisplayMandatory from '@/views/trade/perfect2022/components/display-mandatory'
import RegionStr from '@/views/trade/perfect2022/components/region-str.vue'
export default {
  components: {
    ContentHeader,
    SwitchInput,
    RegionSkuDialog,
    RegionBeesBonusBeer,
    DisplayPackDesign,
    DisplayMixin,
    DisplayMandatory,
    RegionStr
  },
  computed: {
  },
  data () {
    return {
      type: '', // new 新建 update 修改 copy 复制
      loading: false,
      themeName: '',
      themeDefineId: '',
      themeList: [], // 全部配置列表
      orgList: [], // 区域列表
      channelList: [], // 渠道列表
      budgetTypeList: [],
      limitInfo: {}, // 实际使用的限制条件
      disableStartDate: {},
      disableEndDate: {},
      bonusTypeScopeList: [], // 费用返还方式
      selectBonusTypeScopeList: [],
      buPackTaskInfo: {}, // 堆箱信息
      packTaskSelected: [],
      buShelvesTaskInfo: {}, // 货架
      shelvesTaskSelected: [],
      buFreezerTaskInfo: {}, // 冰柜
      FreezerTaskSelected: [],
      formData: {
        privateThemeName: '',
        themeDefineId: '',
        originDefineId: '',
        channelCode: '',
        orgCodes: '',
        startDate: '',
        endDate: '',
        bonusTypeScope: '', // 费用返还方式，
        bonusFeeChooseType: '', // 陈列费选择方式 线上现金
        bonusFeeMin: '',
        bonusFeeMax: '',
        bonusFeeScope: '',
        offlineFeeChooseType: '', // 线下现金
        offlineFeeMin: '',
        offlineFeeMax: '',
        offlineFeeScope: '',
        bonusBeerScope: '', // 赠酒sku
        bonusBeerChooseType: '', // 赠酒数选择模式
        bonusBeerMin: '',
        bonusBeerMax: '',
        bonusBeerQtyScope: '',
        beesFeeChooseType: '', // 先蜂购折扣金
        beesFeeMin: '',
        beesFeeMax: '',
        beesFeeScope: '',
        budgetTypeId: '', // 预算池
        taskTypeScope: '',
        themeStatus: '',
        saveFlag: '',
        tradePerfectTaskDefineList: [],
        areaCodes: '',
        entryBrandCode: ''
      },
      taskCheckedList: [],
      activeName: '',
      btnLoading: false,
      areaList: [],
      selectAreaList: [],
      checkAll: false,
      isIndeterminate: false,
      showBudgetDialog: false,
      recordedBrandList: [], // 入账品牌列表
      budgetList: [], // 预算池列表

      reportCycleList: [],

      tradePerfectBonusBeerGroupList: [],
      beesCouponAssignRule: {
        bonusType: '04',
        type: '01',
        validDays: undefined
      },
      strTaskInfo: {}
    }
  },
  created () {
    this.type = this.$route.query.type
    if (this.type !== 'new') {
      this.themeDefineId = this.$route.query.themeDefineId
      this.formData.orgCodes = this.$route.query.orgCode
    }
    this.getBuConfigList()
  },
  methods: {
    // 获取活动信息
    getBuConfigList () {
      this.loading = true
      tradeApi.getBuPerfectTasksConfigList().then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.themeList = res.data.resultData.parentThemeDefineList
          this.orgList = res.data.resultData.orgList
          if (this.type === 'new') {
            if (this.themeList.length === 1) {
              this.themeDefineId = this.themeList[0].themeDefineList[0].themeDefineId
              this.themeName = this.themeList[0].themeDefineList[0].themeName
              this.getChannelList()
            }
            if (this.orgList.length === 1) {
              this.formData.orgCodes = this.orgList[0].orgCode
              this.getLimitInfo()
            }
          } else {
            this.getLimitInfo()
          }
        }
      })
    },
    // 渠道数据
    getChannelList () {
      [{ themeDefineList: this.channelList }] = this.themeList.filter(item => {
        if (item.themeName === this.themeName) {
          return item
        }
      })
      this.formData.channelCode = ''
      if (this.channelList.length === 1) {
        this.themeDefineId = this.channelList[0].themeDefineId
        this.formData.channelCode = this.channelList[0].channelCode
        this.getThemeDefineId()
      }
      this.resetData()
    },
    // 多渠道时设置主题ID
    getThemeDefineId () {
      this.themeDefineId = this.channelList.filter(item => {
        return item.channelCode === this.formData.channelCode
      })[0].themeDefineId
      this.getLimitInfo()
    },
    // bu限制条件
    getLimitInfo () {
      if (!this.themeDefineId || !this.formData.orgCodes) {
        return
      }
      this.resetData()
      this.loading = true
      tradeApi.getBuPerfectTasksConfigInfo({ themeDefineId: this.themeDefineId, orgCode: this.formData.orgCodes }).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.limitInfo = res.data.resultData.originThemeDefineDTO
          this.formData.originDefineId = this.limitInfo.themeDefineId
          let currentDate = new Date(new Date(new Date().toLocaleDateString()).getTime()).getTime() // 当天开始时间

          // bu 配置的任务类型tab及任务信息
          this.getTaskCheckedList()
          if (this.type === 'new') {
            // this.formData.startDate = this.limitInfo.startDate > currentDate ? this.limitInfo.startDate : currentDate
            this.formData.endDate = this.limitInfo.endDate
            this.formData.execDaysMin = this.limitInfo.execDaysMin
            this.formData.execDaysCycle = this.limitInfo.execDaysCycle
          } else {
            this.formData = res.data.resultData.tradePerfectThemeDefineDTO
            this.themeName = this.formData.themeName
            this.formData.orgCodes = res.data.resultData.tradePerfectThemeDefineDTO.orgCode
            if (this.formData.bonusTypeScope.indexOf('04') !== -1) {
              this.tradePerfectBonusBeerGroupList = this.formData.tradePerfectBonusBeerGroupList
              this.beesCouponAssignRule = JSON.parse(this.formData.beesCouponAssignRule)
            }
            this.formData.budgetTypeId = ''
            // region 已选择任务
            this.getTask()
            this.selectBonusTypeScopeList = this.formData.bonusTypeScope.split(',')
          }

          if (this.type === 'copy') {
            this.formData.privateThemeName = ''
            this.formData.themeDefineId = ''
            // this.formData.startDate = this.limitInfo.startDate > currentDate ? this.limitInfo.startDate : currentDate

            // 如果bu取消费用返还方式,region 取消对应的返还方式
            let list = []
            this.formData.bonusTypeScope.split(',').forEach(item => {
              if (this.limitInfo.bonusTypeScope.includes(item)) {
                list.push(item)
              }
            })
            this.formData.bonusTypeScope = list.join()

            this.formData.themeStatus = 0
          }
          this.formData.startDate = this.limitInfo.startDate > currentDate ? this.limitInfo.startDate : currentDate

          this.getReportCycle()
          this.getAreaList()

          // bu 配置的费用返还方式
          this.getBonusTypeScopeList()

          this.formData.taskTypeScope = this.limitInfo.taskTypeScope

          let startDate = this.limitInfo.startDate
          let endDate = this.limitInfo.endDate
          this.disableStartDate = {
            disabledDate (time) {
              return endDate < time.getTime() || time.getTime() < (startDate > currentDate ? startDate : currentDate)
            }
          }
          this.disableEndDate = {
            disabledDate (time) {
              if (startDate < Date.parse(new Date())) {
                return endDate < time.getTime() || time.getTime() < Date.parse(new Date()) - 86400000
              } else {
                return endDate < time.getTime() || time.getTime() < startDate
              }
            }
          }
        }
      })
    },
    resetData () {
      this.selectBonusTypeScopeList = []
      this.formData.bonusTypeScope = ''
      this.$refs?.packDesign?.resetData()
      this.$refs?.packMixin?.resetData()
      this.$refs?.shelvesMandatory?.resetData()
      this.$refs?.shelvesMixin?.resetData()
      this.$refs?.freezerMandatory?.resetData()
      this.$refs?.freezerMixin?.resetData()
    },
    // 检查活动日期
    checkData () {
      if (this.formData.startDate && this.formData.endDate && this.formData.startDate > this.formData.endDate) {
        [this.formData.startDate, this.formData.endDate] = [this.formData.endDate, this.formData.startDate]
      }
      this.getReportCycle()
    },
    // 费用返还方式
    getBonusTypeScopeList () {
      this.bonusTypeScopeList = this.limitInfo.bonusTypeScope.split(',').map(item => {
        item = { value: item }
        switch (item.value) {
          case '01':
            item.key = '线上现金返还'
            item.type = 0
            break
          case '02':
            item.key = '线下现金返还'
            item.type = 0
            break
          case '03':
            item.key = '线下免费酒返还'
            item.type = 0
            break
          case '04':
            item.key = '先蜂购线上免费酒返还'
            item.type = 1
            break
          case '05':
            item.key = '先蜂购线上折扣金返还'
            item.type = 1
            break
        }
        return item
      })
    },
    // 费用返还方式是否包含交易售点选项
    checkBonusTypeScopeType (list, mode) {
      return list.find(item => {
        return item.type === mode
      })
    },
    // switchInput
    // 线上现金返还
    getOnlineFeeSwitchValue (str) {
      let data = []
      if (str === '01') {
        data.push(this.formData.bonusFeeMin)
        data.push(this.formData.bonusFeeMax)
      } else if (str === '02') {
        data.push(this.formData.bonusFeeScope)
      }
      return data
    },
    // 线下现金返还
    getOfflineFeeSwitchValue (str) {
      let data = []
      if (str === '01') {
        data.push(this.formData.offlineFeeMin)
        data.push(this.formData.offlineFeeMax)
      } else if (str === '02') {
        data.push(this.formData.offlineFeeScope)
      }
      return data
    },
    // 赠酒
    getBeerSwitchValue (str) {
      let data = []
      if (str === '01') {
        data.push(this.formData.bonusBeerMin)
        data.push(this.formData.bonusBeerMax)
      } else if (str === '02') {
        data.push(this.formData.bonusBeerQtyScope)
      }
      return data
    },
    getBeesBonusFee (str) {
      let data = []
      if (str === '01') {
        data.push(this.formData.beesFeeMin)
        data.push(this.formData.beesFeeMax)
      } else if (str === '02') {
        data.push(this.formData.beesFeeScope)
      }
      return data
    },
    // bu配置的任务列表
    getTaskCheckedList () {
      this.taskCheckedList = this.limitInfo.taskTypeScope.split(',').map(item => {
        item = { key: item }
        if (item.key === '01') {
          item.title = '堆箱任务'
        } else if (item.key === '02') {
          item.title = '货架任务'
        } else if (item.key === '03') {
          item.title = '冰柜任务'
        } else if (item.key === '05') {
          item.title = 'STR任务'
        }
        return item
      })
      this.limitInfo.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '01') {
          this.buPackTaskInfo = item
        } else if (item.taskType === '02') {
          this.buShelvesTaskInfo = item
        } else if (item.taskType === '03') {
          this.buFreezerTaskInfo = item
        }
      })
      this.activeName = this.taskCheckedList[0].title
    },
    // 获取已选择任务
    getTask () {
      this.formData.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '01') {
          this.packTaskSelected = item
        } else if (item.taskType === '02') {
          this.shelvesTaskSelected = item
        } else if (item.taskType === '03') {
          this.FreezerTaskSelected = item
        } else if (item.taskType === '05') {
          this.strTaskInfo = item
        }
      })
    },
    // 预算池金额千分符格式化(xin)
    newThousandSymbol (value) {
      value.availableAmount = value.availableAmount.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let str = `可用预算 ${value.availableAmount}`
      return str
    },
    // 获取area列表
    getAreaList () {
      this.selectAreaList = []
      tradeApi.getAreaList({ regionCode: this.formData.orgCodes }).then(res => {
        if (res.data.resultCode === '0') {
          this.areaList = res.data.resultData.regionList
          if (this.type === 'new' || !this.formData.areaCodes) {
            this.selectAreaList = this.areaList.map(item => {
              return item.orgCode
            })
          } else {
            this.selectAreaList = this.formData.areaCodes ? this.formData.areaCodes.split(',') : []
          }
          if (this.selectAreaList.length === this.areaList.length) {
            this.checkAll = true
          }
        }
      })
    },
    // 全选area
    handleCheckAllChange (val) {
      let list = this.areaList.map(item => {
        return item.orgCode
      })
      this.selectAreaList = val ? list : []
      this.isIndeterminate = false
    },
    // area判断全选
    handleCheckedAreaChange (value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.areaList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.areaList.length
    },
    // 计算打卡周期
    getReportCycle () {
      if (!this.formData.startDate || !this.formData.endDate) {
        return
      }
      let startDate = moment(moment(this.formData.startDate).startOf('month').format('YYYY-MM-DD'))
      let endDate = moment(moment(this.formData.endDate).endOf('month').format('YYYY-MM-DD'))
      let startYear = startDate.format('YYYY')
      let startMonth = startDate.format('M')
      let list = []
      for (let i = startMonth; i < endDate.diff(startDate, 'months') + 1 + parseInt(startMonth); i++) {
        let month = (i % 12) === 0 ? 12 : (i % 12)
        let num = i % 12 === 0 ? Math.floor(i / 12) - 1 : Math.floor(i / 12)
        let year = parseInt(startYear) + num
        let obj = {
          year,
          month: month > 9 ? month + '' : '0' + month
        }
        list.push(obj)
      }
      this.reportCycleList = list
    },
    // 费用返还方式
    setBonusTypeScope () {
      this.formData.bonusTypeScope = this.selectBonusTypeScopeList.sort((a, b) => {
        return a - b
      }).join()
      if (this.formData.bonusTypeScope.indexOf('04') === -1 && this.formData.bonusTypeScope.indexOf('05') === -1) {
        this.activeName = this.taskCheckedList[0].title
      }
    },
    // 线上现金返还 陈列费
    setOnlineBonusFee () {
      this.formData.bonusFeeChooseType = this.$refs.onlineBonusFee.chooseType
      // let reg = /^[0-9]+$/
      let reg = /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
      if (this.formData.bonusFeeChooseType === '01') {
        this.formData.bonusFeeMin = this.$refs.onlineBonusFee.startValue
        this.formData.bonusFeeMax = this.$refs.onlineBonusFee.endValue

        if ((!this.formData.bonusFeeMin && this.formData.bonusFeeMin !== 0) || (!this.formData.bonusFeeMax && this.formData.bonusFeeMax !== 0)) {
          this.$message.warning('请输入线上现金返还设置陈列费')
          return false
        }
        if (this.formData.bonusFeeMin > this.formData.bonusFeeMax) {
          this.$message.warning('请检查线上现金返还设置陈列费')
          return false
        }
        if (!reg.test(this.formData.bonusFeeMin) || !reg.test(this.formData.bonusFeeMax)) {
          this.$message.warning('线上现金返还设置陈列费只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }
        return true
      } else {
        let list = [...new Set(this.$refs.onlineBonusFee.inputList)]
        list = list.filter(item => {
          if (item !== undefined) {
            return true
          }
        })
        if (!list.every(item => {
          return reg.test(item)
        })) {
          this.$message.warning('线上现金返还设置陈列费只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }

        this.formData.bonusFeeScope = list.join(',')
        if (this.formData.bonusFeeScope.length === 0) {
          this.$message.warning('请输入线上现金返还设置陈列费')
          return false
        }
        return true
      }
    },
    // 线下现金返还 陈列费
    setOfflineBonusFee () {
      this.formData.offlineFeeChooseType = this.$refs.offlineBonusFee.chooseType
      // let reg = /^[0-9]+$/
      let reg = /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
      if (this.formData.offlineFeeChooseType === '01') {
        this.formData.offlineFeeMin = this.$refs.offlineBonusFee.startValue
        this.formData.offlineFeeMax = this.$refs.offlineBonusFee.endValue

        if ((!this.formData.offlineFeeMin && this.formData.offlineFeeMin !== 0) || (!this.formData.offlineFeeMax && this.formData.offlineFeeMax !== 0)) {
          this.$message.warning('请输入线下现金返还设置陈列费')
          return false
        }
        if (this.formData.offlineFeeMin > this.formData.offlineFeeMax) {
          this.$message.warning('请检查线下现金返还设置陈列费')
          return false
        }
        if (!reg.test(this.formData.offlineFeeMin) || !reg.test(this.formData.offlineFeeMax)) {
          this.$message.warning('线下现金返还设置陈列费只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }
        return true
      } else {
        let list = [...new Set(this.$refs.offlineBonusFee.inputList)]
        list = list.filter(item => {
          if (item !== undefined) {
            return true
          }
        })
        if (!list.every(item => {
          return reg.test(item)
        })) {
          this.$message.warning('线下现金返还设置陈列费只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }

        this.formData.offlineFeeScope = list.join(',')
        if (this.formData.offlineFeeScope.length === 0) {
          this.$message.warning('请输入线下现金返还设置陈列费')
          return false
        }
        return true
      }
    },
    // 赠酒数
    setBonusBeerQty () {
      this.formData.bonusBeerChooseType = this.$refs.BonusBeer.chooseType
      let reg = /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
      if (this.formData.bonusBeerChooseType === '01') {
        this.formData.bonusBeerMin = this.$refs.BonusBeer.startValue
        this.formData.bonusBeerMax = this.$refs.BonusBeer.endValue
        if ((!this.formData.bonusBeerMin && this.formData.bonusBeerMin !== 0) || (!this.formData.bonusBeerMax && this.formData.bonusBeerMax !== 0)) {
          this.$message.warning('请输入线下免费酒返还赠酒数')
          return false
        }
        if (this.formData.bonusBeerMin > this.formData.bonusBeerMax) {
          this.$message.warning('请检查线下免费酒返还赠酒数')
          return false
        }
        // let reg = /^[0-9]+$/
        if (!reg.test(this.formData.bonusBeerMin) || !reg.test(this.formData.bonusBeerMax)) {
          this.$message.warning('线下免费酒返还设置赠酒数只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }
        return true
      } else {
        // let reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/
        let list = [...new Set(this.$refs.BonusBeer.inputList)]
        list = list.filter(item => {
          if (item !== undefined) {
            return true
          }
        })
        if (!list.every(item => {
          return reg.test(item)
        })) {
          this.$message.warning('线下免费酒返还设置赠酒数只能填写大于等于零的数字，且最多保留两位小数')
          return false
        }
        this.formData.bonusBeerQtyScope = list.join(',')
        if (this.formData.bonusBeerQtyScope.length === 0) {
          this.$message.warning('请输入线下免费酒返还赠酒数')
          return false
        }
        return true
      }
    },
    // 先蜂购线上免费酒
    setBeesBonusBeer () {
      let list = this.$refs.BonusBeerOnline.getValue()
      let groupNameList = []
      // let skuInfoList = []
      let groupInfoList = []
      for (let i = 0; i < list.length; i++) {
        if (!list[i].groupName) {
          this.$message.warning(`请填写先蜂购线上免费酒返还，奖励组合${i + 1} 组合名称`)
          return false
        }
        if (groupNameList.includes(list[i].groupName)) {
          this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1} 组合名称重复，请修改后提交`)
          return false
        }
        groupNameList.push(list[i].groupName)
        let skuCodeList = []
        let monthNum = {}
        for (let j = 0; j < list[i].bonusDetail.length; j++) {
          if (!list[i].bonusDetail[j].skuCode) {
            this.$message.warning(`请选择先蜂购线上免费酒返还，奖励组合${i + 1} 赠酒SKU`)
            return false
          }
          // 同一组合内有重复SKU
          if (skuCodeList.includes(list[i].bonusDetail[j].skuCode)) {
            this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1} SKU重复，请修改后提交`)
            return false
          }
          // 不同组合内有重复SKU
          // if (skuInfoList.find(item => item.skuCode === list[i].bonusDetail[j].skuCode)) {
          //   let repeatSkuInfo = skuInfoList.find(item => item.skuCode === list[i].bonusDetail[j].skuCode)
          //   let canReturn = false
          //   // let groupNumber = ''
          //   for (let repeatIndex = 0; repeatIndex < repeatSkuInfo.values.length; repeatIndex++) {
          //     for (let skuIndex = 0; skuIndex < list[i].bonusDetail[j].values.length; skuIndex++) {
          //       // groupNumber = repeatSkuInfo.groupNumber
          //       // 相同sku 每月赠酒数有不同
          //       if (repeatSkuInfo.values[repeatIndex].month === list[i].bonusDetail[j].values[skuIndex].month && repeatSkuInfo.values[repeatIndex].value !== list[i].bonusDetail[j].values[skuIndex].value) {
          //         canReturn = true
          //       }
          //     }
          //   }
          //   if (!canReturn) {
          //     // this.$message.warning(`先蜂购线上免费酒返还，奖励组合${groupNumber + 1}与奖励组合${i + 1} 重复，请修改后提交`)
          //     return false
          //   }
          // }

          // 每月赠酒数是否未填写
          for (let numIndex = 0; numIndex < list[i].bonusDetail[j].values.length; numIndex++) {
            let num = list[i].bonusDetail[j].values[numIndex]
            if (!num.value && num.value !== 0) {
              this.$message.warning(`请填写先蜂购线上免费酒返还，奖励组合${i + 1} SKU:${list[i].bonusDetail[j].skuName} ${num.month}返还数量`)
              return false
            }
          }

          // 单月奖励总和是否为0
          for (let numIndex = 0; numIndex < list[i].bonusDetail[j].values.length; numIndex++) {
            let num = list[i].bonusDetail[j].values[numIndex]
            // monthNum[num.month] += parseInt(num.value)
            monthNum[num.month] = monthNum[num.month] ? monthNum[num.month] : 0
            monthNum[num.month] += num.value
          }
          skuCodeList.push(list[i].bonusDetail[j].skuCode)
          // list[i].bonusDetail[j].groupNumber = i
          // skuInfoList.push(list[i].bonusDetail[j])
        }

        // 奖励组合重复
        let sortList = JSON.parse(JSON.stringify(list[i].bonusDetail)).map(item => {
          delete item.isActiveUUID
          return item
        }).sort((a, b) => {
          return a.skuCode - b.skuCode
        })
        let isRepeat = groupInfoList.findIndex(item => {
          return item === JSON.stringify(sortList)
        })
        if (isRepeat !== -1) {
          this.$message.warning(`先蜂购线上免费酒返还，奖励组合${isRepeat + 1}与奖励组合${i + 1} 重复，请修改后提交`)
          return false
        }
        groupInfoList.push(JSON.stringify(sortList))

        // 单月奖励总和是否为0
        for (const month in monthNum) {
          if (monthNum[month] === 0) {
            this.$message.warning(`先蜂购线上免费酒返还，奖励组合${i + 1}: ${month.slice(0, 4)}年${month.slice(5, 7)}月单月奖励总和不能为0`)
            return
          }
        }
      }

      if (this.beesCouponAssignRule.type === '01' && !this.beesCouponAssignRule.validDays) {
        this.$message.warning('请填写先蜂购线上免费酒返还，赠酒券有效时间')
        return
      }
      this.formData.beesCouponAssignRule = JSON.stringify(this.beesCouponAssignRule)

      list = JSON.parse(JSON.stringify(list))
      for (let i = 0; i < list.length; i++) {
        list[i].bonusDetail = JSON.stringify(list[i].bonusDetail)
      }
      this.formData.tradePerfectBonusBeerGroupList = list
      return true
    },
    // 赠酒券
    shiftBeesCouponAssignRule (val) {
      if (val === '02') {
        this.beesCouponAssignRule.validDays = undefined
      }
    },
    // 先蜂购线上折扣金
    setBeesDiscount () {
      this.formData.beesFeeChooseType = this.$refs.beesFeeBonus.chooseType
      // let reg = /^[0-9]+$/
      let reg = /^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/
      if (this.formData.beesFeeChooseType === '01') {
        this.formData.beesFeeMin = this.$refs.beesFeeBonus.startValue
        this.formData.beesFeeMax = this.$refs.beesFeeBonus.endValue
        if ((!this.formData.beesFeeMin && this.formData.beesFeeMin !== 0) || (!this.formData.beesFeeMax && this.formData.beesFeeMax !== 0)) {
          this.$message.warning('请输入先蜂购线上折扣金返还设置折扣金额')
          return false
        }
        if (this.formData.beesFeeMin > this.formData.beesFeeMax) {
          this.$message.warning('请检查先蜂购线上折扣金返还设置折扣金额')
          return false
        }
        if (!reg.test(this.formData.beesFeeMin) || !reg.test(this.formData.beesFeeMax)) {
          this.$message.warning('先蜂购线上折扣金返还设置折扣金额只能填写大于零的数字，且最多保留两位小数')
          return false
        }
        return true
      } else {
        let list = [...new Set(this.$refs.beesFeeBonus.inputList)]
        list = list.filter(item => {
          if (item !== undefined) {
            return true
          }
        })
        if (!list.every(item => {
          return reg.test(item)
        })) {
          this.$message.warning('先蜂购线上折扣金返还设置折扣金额只能填写大于零的数字，且最多保留两位小数')
          return false
        }

        this.formData.beesFeeScope = list.join(',')
        if (this.formData.beesFeeScope.length === 0) {
          this.$message.warning('请输入先蜂购线上折扣金返还设置折扣金额')
          return false
        }
        return true
      }
    },
    // 陈列任务
    setTaskList (val) {
      this.formData.tradePerfectTaskDefineList = []
      this.recordedBrandList = []
      // bu 开启堆箱任务
      if (this.limitInfo.taskTypeScope.indexOf('01') !== -1) {
        let packInfo = {
          taskDefineId: this.packTaskSelected.taskDefineId,
          taskType: '01'
        }
        if (this.type === 'new' || this.type === 'copy') {
          packInfo.taskDefineId = ''
        }

        // 堆箱设计配置
        let packTaskList = this.$refs.packDesign?.selectDataList || []
        packInfo.mixinPackScopeList = packTaskList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }
          // trCode
          item.brandList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.abiBrandName
            params.brandCode = subItem.abiBrandCode
            this.recordedBrandList.push(params)
          })
          return obj
        })

        // 堆箱组合陈列
        let packMixinList = this.$refs.packMixin?.selectDataList || []
        packInfo.mixinDisplayScopeList = packMixinList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }
          // trCode
          item.brandList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.abiBrandName
            params.brandCode = subItem.abiBrandCode
            this.recordedBrandList.push(params)
          })
          item.tradePerfectScopeDetailList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.subBrandDTO.abiBrandName
            params.brandCode = subItem.subBrandDTO.abiBrandCode
            this.recordedBrandList.push(params)
          })

          return obj
        })
        // 配置了堆箱任务 需填写单张拍照激励金额
        if (packTaskList.length !== 0 || packMixinList.length !== 0) {
          this.formData.tradePerfectTaskDefineList.push(packInfo)
        }
      }
      // bu 开启货架任务
      if (this.limitInfo.taskTypeScope.indexOf('02') !== -1) {
        let shelvesInfo = {
          taskDefineId: this.shelvesTaskSelected.taskDefineId,
          taskType: '02'
        }
        if (this.type === 'new' || this.type === 'copy') {
          shelvesInfo.taskDefineId = ''
        }

        // 货架必备品
        let shelvesMandatoryList = this.$refs.shelvesMandatory?.selectDataList || []
        shelvesInfo.mandatoryScopeList = shelvesMandatoryList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }

          // trCode
          item.tradePerfectScopeDetailList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.subBrandDTO.abiBrandName
            params.brandCode = subItem.subBrandDTO.abiBrandCode
            this.recordedBrandList.push(params)
          })
          return obj
        })

        // 货架组合陈列
        let shelvesMixinList = this.$refs.shelvesMixin?.selectDataList || []
        shelvesInfo.mixinDisplayScopeList = shelvesMixinList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }

          // trCode
          item.brandList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.abiBrandName
            params.brandCode = subItem.abiBrandCode
            this.recordedBrandList.push(params)
          })
          item.tradePerfectScopeDetailList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.subBrandDTO.abiBrandName
            params.brandCode = subItem.subBrandDTO.abiBrandCode
            this.recordedBrandList.push(params)
          })
          return obj
        })

        if (shelvesMandatoryList.length !== 0 || shelvesMixinList.length !== 0) {
          this.formData.tradePerfectTaskDefineList.push(shelvesInfo)
        }
      }
      // bu 开启冰柜任务
      if (this.limitInfo.taskTypeScope.indexOf('03') !== -1) {
        let freezerInfo = {
          taskDefineId: this.FreezerTaskSelected.taskDefineId,
          taskType: '03'
        }
        if (this.type === 'new' || this.type === 'copy') {
          freezerInfo.taskDefineId = ''
        }

        // 冰柜必备品
        let freezerMandatoryList = this.$refs.freezerMandatory?.selectDataList || []
        freezerInfo.mandatoryScopeList = freezerMandatoryList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }
          // trCode
          item.tradePerfectScopeDetailList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.subBrandDTO.abiBrandName
            params.brandCode = subItem.subBrandDTO.abiBrandCode
            this.recordedBrandList.push(params)
          })

          return obj
        })

        // 冰柜组合陈列
        let freezerMixinList = this.$refs.freezerMixin?.selectDataList || []
        freezerInfo.mixinDisplayScopeList = freezerMixinList.map(item => {
          let obj = {
            scopeDefineId: item.scopeDefineId,
            sequenceFlag: item.sequenceFlag
          }
          // trCode
          item.brandList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.abiBrandName
            params.brandCode = subItem.abiBrandCode
            this.recordedBrandList.push(params)
          })
          item.tradePerfectScopeDetailList.forEach(subItem => {
            let params = {}
            params.brandName = subItem.subBrandDTO.abiBrandName
            params.brandCode = subItem.subBrandDTO.abiBrandCode
            this.recordedBrandList.push(params)
          })

          return obj
        })

        if (freezerMandatoryList.length !== 0 || freezerMixinList.length !== 0) {
          this.formData.tradePerfectTaskDefineList.push(freezerInfo)
        }
      }
      if (!this.formData.tradePerfectTaskDefineList.length) {
        this.$message.warning('请至少配置一种陈列任务')
        return false
      }
      // bu 开启STR任务 并且选中先蜂购返还方式
      if (this.limitInfo.taskTypeScope.indexOf('05') !== -1 && (this.formData.bonusTypeScope.indexOf('04') !== -1 || this.formData.bonusTypeScope.indexOf('05') !== -1)) {
        let list = this.$refs.regionStr.setValue()
        if (!list) {
          return false
        } else if (list !== true) {
          // 配置STR任务， 活动结束时间应为月最后一天
          if (list.length) {
            let year = new Date(this.formData.endDate).getFullYear()
            let month = new Date(this.formData.endDate).getMonth() + 1
            let newMonth = ++month
            if (newMonth === 13) {
              year++
              month = 1
            }
            // 当月最后一天
            let date = new Date(`${year}/${month}`).getTime() - 86400000
            if (this.formData.endDate < date) {
              this.$message.warning('已配置STR任务，活动结束时间必须为该月最后一天')
              return false
            }
          }

          this.formData.tradePerfectTaskDefineList.push({
            taskType: '05',
            taskName: 'STR',
            taskDefineId: this.type === 'copy' ? '' : this.strTaskInfo.taskDefineId,
            saleScopeList: list
          })
        }
      }
      // 陈列任务入账品牌去重
      this.recordedBrandList = this.recordedBrandList.filter((item, index) => {
        return this.recordedBrandList.findIndex(item1 => item1.brandCode === item.brandCode) === index
      })
      return true
    },
    // 未设置任务时修改已选择任务
    setTaskStr () {
      let str = ''
      this.formData.tradePerfectTaskDefineList.forEach(item => {
        str += item.taskType + ','
      })
      str = str.slice(0, str.length - 1)
      this.formData.taskTypeScope = str
    },

    // 验证
    execFormData (val) {
      if (!this.formData.privateThemeName) {
        this.$message.warning('请输入活动名称')
        return
      }
      if (this.formData.privateThemeName.length > 50) {
        this.$message.warning('活动名称最多五十字')
        return false
      }
      this.formData.privateThemeName = this.formData.privateThemeName.trim()
      if (!this.formData.startDate || !this.formData.endDate) {
        this.$message.warning('请选择活动时间')
        return
      }
      if (!this.formData.execDaysMin) {
        this.$message.warning('请填写最少执行时间')
        return
      }
      if (this.formData.execDaysMin < this.limitInfo.execDaysMin) {
        this.$message.warning('最少执行时间不能小于上级配置的最少执行时间')
        return
      }
      let diffDate = moment(this.formData.endDate).diff(moment(this.formData.startDate), 'days', true)
      if (this.formData.execDaysMin > Math.floor(diffDate) + 1) {
        this.$message.warning('最少执行时间大于活动时间')
        return
      }
      if (!this.formData.execDaysCycle) {
        this.$message.warning('请填写打卡频次')
        return
      }
      if (this.formData.execDaysCycle > this.limitInfo.execDaysCycle) {
        this.$message.warning('打卡频次不能低于上级配置的打卡频次')
        return
      }
      this.setBonusTypeScope()
      if (this.formData.bonusTypeScope.length === 0) {
        this.$message.warning('请选择费用返还方式')
        return
      }
      if (this.formData.bonusTypeScope.indexOf('01') !== -1) {
        if (!this.setOnlineBonusFee()) {
          return
        }
      }

      if (this.formData.bonusTypeScope.indexOf('02') !== -1) {
        if (!this.setOfflineBonusFee()) {
          return
        }
      }

      if (this.formData.bonusTypeScope.indexOf('03') !== -1) {
        if (!this.$refs.bonusBeerSku.selectedSku.length) {
          this.$message.warning('请选择线下免费酒返还，赠酒SKU')
          return
        } else {
          this.formData.bonusBeerScope = JSON.stringify(this.$refs.bonusBeerSku.selectedSku)
        }
        if (!this.setBonusBeerQty()) {
          return
        }
      }
      this.formData.beesCouponAssignRule = ''
      if (this.formData.bonusTypeScope.indexOf('04') !== -1) {
        if (!this.setBeesBonusBeer()) {
          return
        }
      }

      if (this.formData.bonusTypeScope.indexOf('05') !== -1) {
        if (!this.setBeesDiscount()) {
          return
        }
      }

      // if (this.isBonusTypeFeeOnLine && !this.formData.budgetTypeId) {
      //   this.$message.warning('请选择预算池')
      //   return
      // }
      // 陈列任务
      if (!this.setTaskList(val)) {
        return
      }
      // str任务
      this.setTaskStr()

      if (this.selectAreaList.length) {
        this.formData.areaCodes = this.selectAreaList.sort((a, b) => {
          return a - b
        }).join()
      } else {
        this.formData.areaCodes = ''
      }
      this.formData.saveFlag = 0
      if (val === 2) {
        this.formData.saveFlag = 1

        this.formData.entryBrandCode = ''
        this.formData.budgetTypeId = ''

        // if (!this.formData.tradePerfectTaskDefineList.length) {
        //   this.$message.warning('请至少配置一种执行任务')
        //   return
        // }
        // 选择传统费用返还方式需选择预算池
        if (this.formData.bonusTypeScope.indexOf('01') !== -1 || this.formData.bonusTypeScope.indexOf('02') !== -1 || this.formData.bonusTypeScope.indexOf('03') !== -1) {
          if (this.recordedBrandList.length === 0) {
            this.$message.warning('入账品牌为空')
            return
          }
          this.showBudgetDialog = true
          this.budgetList = []
          return
        }
        // this.showBudgetDialog = true
        // this.formData.entryBrandCode = ''
        // this.formData.budgetTypeId = ''
        // this.budgetList = []
        // return
      }
      this.handleSubmit()
    },
    // 入账品牌变更
    recordedBrandChange () {
      this.formData.budgetTypeId = ''
      let params = {}
      if (!this.formData.entryBrandCode) {
        this.budgetList = []
        return
      }
      params.regionCode = this.formData.orgCodes
      params.subBrandCode = this.formData.entryBrandCode

      tradeApi.queryBudgetList(params).then(res => {
        if (res.data.resultCode === '0') {
          this.budgetList = res.data.resultData.budgetTypeList
          if (!this.budgetList.length) {
            this.$message.warning('当前入账品牌预算池为空')
          }
        }
      })
    },
    // 预算池取消提交
    budgetCancel () {
      this.showBudgetDialog = false
      this.formData.entryBrandCode = ''
      this.formData.budgetTypeId = ''
      this.budgetList = []
    },
    // 新增 绑定预算池提交
    budgetSubmit () {
      if (!this.formData.entryBrandCode) {
        this.$message.warning('请选择入账品牌')
        return
      }
      if (!this.formData.budgetTypeId) {
        this.$message.warning('请选择预算池')
        return
      }
      this.showBudgetDialog = false
      this.$alert('活动需要BUTM审批后生效', '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: action => {
          this.handleSubmit()
        }
      })
    },
    // 保存提交
    handleSubmit () {
      this.btnLoading = true
      let msg = ''
      if (this.formData.saveFlag === 0) {
        msg = '已成功保存，若需生效请提交审批'
      } else if (this.formData.saveFlag === 1) {
        msg = '已成功提交，BU TM审批后生效'
      }
      if (this.type === 'new' || this.type === 'copy') {
        tradeApi.addPerfectTaskConfig(this.formData).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success(msg)
            this.$router.push({
              path: '/trade/perfect-region-config-list'
            })
          }
          this.btnLoading = false
        }).catch(() => {
          this.btnLoading = false
        })
      }
      if (this.type === 'update') {
        tradeApi.updatePerfectTaskConfig(this.formData).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success(msg)
            this.$router.push({
              path: '/trade/perfect-region-config-list'
            })
          }
          this.btnLoading = false
        }).catch(() => {
          this.btnLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 660px;
}
.el-input-number {
  width: 220px;
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
  display: none;
}
::v-deep .el-input-number .el-input__inner {
  padding: 0;
}
::v-deep .el-input__icon {
  line-height: 30px !important;
}
.title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
.content {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 40px;
  margin-bottom: 30px;
  .item {
    line-height: 60px;
    display: flex;
    border-bottom: 1px solid #ececec;
    .re-title {
      width: 200px;
      font-size: 16px;
      font-weight: 600;
      position: relative;
      .tips {
        font-size: 12px;
        color: #c8102d;
        position: absolute;
        left: 12px;
        top: 18px;
      }
      i {
        color: #c8102d;
        margin-right: 5px;
      }
    }
    .re-content {
      flex: 1;
      font-size: 14px;
      &::v-deep .el-input .el-input__inner {
        height: 30px;
      }
      .el-input {
        width: 240px;
        height: 30px;
        line-height: 30px;
      }
      .exec-cycle-btn {
        height: 30px;
        padding: 7px 15px;
        border-radius: 4px;
        margin-right: 25px;
        font-size: 14px;
      }
      .el-select {
        width: 240px;
      }
      .el-date-picker {
        width: 220px;
      }
      .el-input-number {
        width: 80px;
        &::v-deep .el-input__inner {
          padding: 0;
        }
      }
      .area {
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        ::v-deep .el-checkbox__inner:hover,
        .el-checkbox__input .el-checkbox__inner:focus {
          border-color: #409eff !important;
        }
        ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        display: flex;
        align-items: center;
        .checkbox-group {
          flex-basis: 80%;
        }
        .checkbox-checkAll {
          align-self: flex-start;
          flex-basis: 10%;
        }
      }
      .exec-cycle-btn {
        height: 30px;
        padding: 7px 15px;
        border-radius: 4px;
        margin-right: 25px;
      }
      .bonus {
        background-color: #f8f8f8;
        border-radius: 10px;
        padding: 0px 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        max-width: 930px;
        // line-height: 40px;
        .bonus-title {
          font-size: 14px;
          font-weight: 700;
          padding-left: 20px;
          box-sizing: border-box;
        }
        .bonus-content {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          i {
            color: #c8102d;
            font-size: 16px;
            font-weight: 700;
            margin-right: 10px;
          }
          .el-radio {
            margin-right: 10px;
          }
          .el-radio ::v-deep .el-radio__input {
            display: inline-block;
          }
          .el-radio ::v-deep .el-radio__input.is-checked + .el-radio__label {
            color: #606266;
          }
          .coupon-bonus-beer {
            display: flex;
            line-height: 40px;
            margin: 20px 0 10px;
          }
        }
      }
    }

    .checkbox-info {
      display: flex;
      flex-basis: 80%;
      flex-wrap: wrap;
      // padding: 10px 0;
      &::v-deep .el-checkbox-button__inner {
        height: 30px;
        padding: 7px 15px;
        border-radius: 4px;
        margin-right: 25px;
      }
      .checkbox-wrapper {
        position: relative;
      }
    }
  }
}
// // 任务tabs样式
.regionTask > ::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  border-radius: 0px 10px 10px 10px;
  position: relative;
  .tab-item {
    background-color: #fff;
    padding: 20px 20px;
  }
}
.encourage {
  margin-bottom: 5px;
  background-color: #fff;
  padding: 30px 20px 20px;
  p {
    font-weight: 700;
    margin-top: 0;
    font-size: 16px;
  }
  .encourage-input {
    display: flex;
    &::v-deep .el-input .el-input__inner {
      height: 30px;
    }
    .el-input {
      width: 135px;
      height: 30px;
    }
    span {
      line-height: 38px;
      font-size: 14px;
      margin-right: 20px;
    }
  }
}

.place-dialog,
.shelf-dialog {
  padding: 0 20px 30px;
  &::v-deep .el-dialog__body {
    padding: 0 20px 30px !important;
  }
}
.addplace-search {
  display: flex;
  align-items: center;
  span {
    width: 80px;
    font-size: 14px;
    font-weight: 700;
  }
  .el-input {
    width: 260px;
    margin-right: 20px;
    &::v-deep .el-input__inner {
      height: 30px;
    }
  }
  .el-button {
    height: 30px;
    padding: 0 20px;
  }
}
// .el-dialog {
//   min-width: 1200px;
// }

.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}
.handle-foot {
  width: 300px;
  margin: 0px auto 40px;
  display: flex;
  justify-content: space-around;
}
</style>
<style>
.el-message-box {
  margin-bottom: 235px !important;
}
</style>
